import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-[1280px] mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">漫画分类</h2>
        <p className="text-foreground-500 text-sm mt-2">精选四大分类，总有一款适合你</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg border border-background-200/70 bg-background-50 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-2xl`}></i>
            </div>
            <div className="text-center">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                {cat.label}
              </h3>
              <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}